<template>
  <div>
    <el-row :gutter="10">
      <el-col :span="5">
        <el-card class="box-card">

          <el-input type="textarea" v-model="videoLinksInput"
                    :rows="30"
                    placeholder="请输入视频链接,多个链接请换行"
          ></el-input>
        </el-card>
      </el-col>
      <el-col :span="19">
        <el-button icon="el-icon-search" @click="generateLinks" >解析</el-button>
        <el-divider></el-divider>
        <el-table  :data="generatedLinksInfo" stripe>
          <el-table-column prop="videoLink" label="视频链接"></el-table-column>
          <el-table-column prop="status" label="状态"></el-table-column>
          <el-table-column prop="statusRes" label="状态说明"></el-table-column>
          <el-table-column prop="videoTitle" label="视频标题"></el-table-column>
          <el-table-column prop="authorName" label="作者昵称"></el-table-column>
          <el-table-column prop="createTime" label="发布时间"></el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>
<style>
.text {
  font-size: 14px;
}

.item {
  padding: 18px 0;
}
</style>
<script>
import axios from 'axios'
import dayjs from "dayjs";




export default {
  name: "dyshortlink",
  data() {
    return {
      goodsId: '',
      videoLinks: [],
      videoLinksInput:'',
      generatedLinksInfo: [],
      douyinCode:'',
      originUrl:''
    };
  },
  methods: {
    generateLinks(){
      const _self = this;
      if(this.videoLinksInput === '') {
        alert('请输入视频短链接.')
        return;
      }

      this.videoLinks = this.videoLinksInput.split('\n')
      if(this.videoLinksInput.length === 0) {
        alert('请输入视频短链接.')
        return;
      } else {
        _self.processLink();
      }

    },
    processLink() {
      const _self = this;
      if(this.videoLinks.length > 0) {
        const videoLink = this.videoLinks.shift();
        axios.get("/tp_api_712/wechatSphInfoV1?api_key=8sArXN5ippGEAVAH89nw&url=" + videoLink)
            .then((content) => {
              if (content && content.data) {
                console.log(typeof content.data)
                if (content.data.errCode === 0) {
                  let videoInfo = null;
                  if (content.data.data.feedInfo === undefined) {
                    if (content.data.data.errMsg.type === 1) {
                      videoInfo ={
                        videoLink: videoLink,
                        status: "下架",
                        statusRes: content.data.data.errMsg.title

                      }
                      console.log(videoInfo);
                      _self.generatedLinksInfo.push(videoInfo);
                    }
                    if (content.data.data.errMsg.type === 3) {
                       videoInfo ={
                        videoLink: videoLink,
                        status: "隐私隐藏",
                        statusRes: content.data.data.errMsg.title

                      }
                      _self.generatedLinksInfo.push(videoInfo);
                    }
                  } else {
                     videoInfo ={
                      videoLink: videoLink,
                      status: "在线",
                      authorName: content.data.data.authorInfo.nickname,
                      videoTitle: content.data.data.feedInfo.description,
                      createTime: dayjs.unix(content.data.data.feedInfo.createtime).format('YYYYMMDD'),
                      favCount: content.data.data.feedInfo.favCountFmt,
                      forwardCount: content.data.data.feedInfo.forwardCountFmt,
                      likeCount: content.data.data.feedInfo.likeCountFmt,

                    }
                    _self.generatedLinksInfo.push(videoInfo);

                  }

                } else {
                  _self.generatedLinksInfo.push({videoLink: videoLink,
                    status: "未知需重试",});

                }
              }
              setTimeout(_self.processLink,150)


            });
      } else {
        alert('无待处理的商品链接');
      }
    },
  },
  mounted() {
  },
};
</script>
